// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3e695a93","977":"260ed2f6"}[chunkId] + ".chunk.js";
};